module.exports = __webpack_public_path__ + "img/tabletennis.deb57643.svg";